import React from 'react';
import { theme, css } from 'constants';
import { View, Text } from 'core';
import { lang } from 'lang';
import { IcoSucess } from 'icons';
const styles = css({
  content_style: {
    padding: 30,
    alignItems: 'center'
  },
  text: {
    textAlign: 'center',
    marginTop: 30,
    marginBottom: 30,
    lineHeight: 22,
    fontSize: 16
  },
  code: {
    fontSize: 30,
    textAlign: 'center'
  }
});

export const NewGroup = ({ current_msg }) => (
  <View style={styles.content_style}>
    <IcoSucess size={60} color={theme.success_color} />
    <Text style={styles.text}>{lang.SYSTEM_MSG.GROUP_CREATED(current_msg)}</Text>
    <Text style={styles.code}>{current_msg.data.code}</Text>
  </View>
);



// WEBPACK FOOTER //
// ./src/components/middle/chat/msgs/new_group.js